import { KYMW1104Component } from './kymw1104.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * アイテム付替画面の値を管理するクラス
 *
 * @export KYMW1104Model
 * @class KYMW1104Model
 */
export class KYMW1104Model {

  kymw1104Component: KYMW1104Component;

  public itemCodeListTmp: Array<any> = new Array<any>();

  public ibaraki_ItemCodeList: Array<any> = new Array<any>();

  public tochigi_ItemCodeList: Array<any> = new Array<any>();

  public gunma_ItemCodeList: Array<any> = new Array<any>();

  public chiba_ItemCodeList: Array<any> = new Array<any>();

  public saitama_ItemCodeList: Array<any> = new Array<any>();

  public tokyo_ItemCodeList: Array<any> = new Array<any>();

  public nagano_ItemCodeList: Array<any> = new Array<any>();

  public niigata_ItemCodeList: Array<any> = new Array<any>();

  public ibaraki_ItemCode: string = <string>'';

  public tochigi_ItemCode: string = <string>'';

  public gunma_ItemCode: string = <string>'';

  public chiba_ItemCode: string = <string>'';

  public saitama_ItemCode: string = <string>'';

  public tokyo_ItemCode: string = <string>'';

  public nagano_ItemCode: string = <string>'';

  public niigata_ItemCode: string = <string>'';

  public ibarakiItemCode: string = <string>'';
  public tochigiItemCode: string = <string>'';
  public gunmaItemCode: string = <string>'';
  public chibaItemCode: string = <string>'';
  public saitamaItemCode: string = <string>'';
  public tokyoItemCode: string = <string>'';
  public naganoItemCode: string = <string>'';
  public niigataItemCode: string = <string>'';

  public goodsMasterEditCount: number = <number>0;

  // バインド用変数
  public pCode: string = <string>'';
  public guideGoodsName: string = <string>'';
  public guideStandardName: string = <string>'';

  public enabledSetItem: boolean = <boolean>false;
  public enabledIbaraki_ItemCode: boolean = <boolean>true;
  public enabledTochigi_ItemCode: boolean = <boolean>true;
  public enabledGunma_ItemCode: boolean = <boolean>true;
  public enabledChiba_ItemCode: boolean = <boolean>true;
  public enabledSaitama_ItemCode: boolean = <boolean>true;
  public enabledTokyo_ItemCode: boolean = <boolean>true;
  public enabledNagano_ItemCode: boolean = <boolean>true;
  public enabledNiigata_ItemCode: boolean = <boolean>true;


  /**
   * アイテムコードコンボボックス初期化
   *
   * @param {*} serverData
   * @memberof KYMW1104Model
   */
  public updateInitItemCodeComboList(serverData: any): void {
    this.itemCodeListTmp = serverData.ItemCodeList.map(i => i.ItemCode);

    this.ibaraki_ItemCodeList = serverData.ItemCodeList.map(i => i.ItemCode);

    this.tochigi_ItemCodeList = serverData.ItemCodeList.map(i => i.ItemCode);

    this.gunma_ItemCodeList = serverData.ItemCodeList.map(i => i.ItemCode);

    this.chiba_ItemCodeList = serverData.ItemCodeList.map(i => i.ItemCode);

    this.saitama_ItemCodeList = serverData.ItemCodeList.map(i => i.ItemCode);

    this.tokyo_ItemCodeList = serverData.ItemCodeList.map(i => i.ItemCode);

    this.nagano_ItemCodeList = serverData.ItemCodeList.map(i => i.ItemCode);

    this.niigata_ItemCodeList = serverData.ItemCodeList.map(i => i.ItemCode);
  }

  /**
   * アイテムコード選択状態設定
   *
   * @param {*} serverData
   * @memberof KYMW1104Model
   */
  public updateSelectedCodesForCoops(serverData: any): void {
    if (!PlessViewUtilsSub.isEmpty(serverData.SelectedItemCode.Ibaraki)) {
      this.ibarakiItemCode = serverData.SelectedItemCode.Ibaraki;
      this.ibaraki_ItemCode = this.itemCodeCheck(this.ibarakiItemCode);
    } else {
      this.ibaraki_ItemCodeList = null;
      this.enabledIbaraki_ItemCode = false;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.SelectedItemCode.Tochigi)) {
      this.tochigiItemCode = serverData.SelectedItemCode.Tochigi;
      this.tochigi_ItemCode = this.itemCodeCheck(this.tochigiItemCode);
    } else {
      this.tochigi_ItemCodeList = null;
      this.enabledTochigi_ItemCode = false;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.SelectedItemCode.Gunma)) {
      this.gunmaItemCode = serverData.SelectedItemCode.Gunma;
      this.gunma_ItemCode = this.itemCodeCheck(this.gunmaItemCode);
    } else {
      this.gunma_ItemCodeList = null;
      this.enabledGunma_ItemCode = false;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.SelectedItemCode.Chiba)) {
      this.chibaItemCode = serverData.SelectedItemCode.Chiba;
      this.chiba_ItemCode = this.itemCodeCheck(this.chibaItemCode);
    } else {
      this.chiba_ItemCodeList = null;
      this.enabledChiba_ItemCode = false;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.SelectedItemCode.Saitama)) {
      this.saitamaItemCode = serverData.SelectedItemCode.Saitama;
      this.saitama_ItemCode = this.itemCodeCheck(this.saitamaItemCode);
    } else {
      this.saitama_ItemCodeList = null;
      this.enabledSaitama_ItemCode = false;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.SelectedItemCode.Tokyo)) {
      this.tokyoItemCode = serverData.SelectedItemCode.Tokyo;
      this.tokyo_ItemCode = this.itemCodeCheck(this.tokyoItemCode);
    } else {
      this.tokyo_ItemCodeList = null;
      this.enabledTokyo_ItemCode = false;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.SelectedItemCode.Nagano)) {
      this.naganoItemCode = serverData.SelectedItemCode.Nagano;
      this.nagano_ItemCode = this.itemCodeCheck(this.naganoItemCode);
    } else {
      this.nagano_ItemCodeList = null;
      this.enabledNagano_ItemCode = false;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.SelectedItemCode.Niigata)) {
      this.niigataItemCode = serverData.SelectedItemCode.Niigata;
      this.niigata_ItemCode = this.itemCodeCheck(this.niigataItemCode);
    } else {
      this.niigata_ItemCodeList = null;
      this.enabledNiigata_ItemCode = false;
    }

    // setTimeout(() => {
      if (this.enabledIbaraki_ItemCode) {
        this.kymw1104Component.cmb_IbarakiItemCode.nativeElement.focus();
        return;
      } else if (this.enabledTochigi_ItemCode) {
        this.kymw1104Component.cmb_TochigiItemCode.nativeElement.focus();
        return;
      } else if (this.enabledGunma_ItemCode) {
        this.kymw1104Component.cmb_GunmaItemCode.nativeElement.focus();
        return;
      } else if (this.enabledChiba_ItemCode) {
        this.kymw1104Component.cmb_ChibaItemCode.nativeElement.focus();
        return;
      } else if (this.enabledSaitama_ItemCode) {
        this.kymw1104Component.cmb_SaitamaItemCode.nativeElement.focus();
        return;
      } else if (this.enabledTokyo_ItemCode) {
        this.kymw1104Component.cmb_TokyoItemCode.nativeElement.focus();
        return;
      } else if (this.enabledNagano_ItemCode) {
        this.kymw1104Component.cmb_NaganoItemCode.nativeElement.focus();
        return;
      } else if (this.enabledNiigata_ItemCode) {
        this.kymw1104Component.cmb_NiigataItemCode.nativeElement.focus();
        return;
      } else {
        this.kymw1104Component.btn_CloseWindow.nativeElement.focus();
        return;
      }
    // });
  }

  /**
   * Itemコードがある時にtrue[1]を返す。
   */
  public itemCodeCheck(itemCode: string): string {
    for (let i = Number(0); i < this.itemCodeListTmp.length; i++) {
      if (PlessViewUtilsSub.trim(this.itemCodeListTmp[i]) === itemCode) {
        return this.itemCodeListTmp[i];
      }
    }

    return '';
  }
}
